<template>
    <access-denied v-if="accessDenied" title="rota" />
    <div id="main" v-else>
        <loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('tipo-servico') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('promotor') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('cadastros') }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'tipo-servico-list' })">
                                        {{ $t('tipo-servico') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? $route.params.id
                                                : $t('adicionar') + ' ' + $t('tipo-servico')
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `tipo-servico-list` })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="saveTipoServico()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <template v-if="isUpdate">
                    <ul class="nav nav-tabs nav-tabs-children">
                        <li
                            v-for="(aba, i) in abas"
                            :key="i"
                            v-show="permissao.read"
                            :class="{ active: abaSelecionada == i }"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul>

                    <!-- CONJUNTO DE ABAS - MOBILE -->
                    <b-dropdown aria-role="list" class="mobile-tab-list">
                        <div slot="trigger" class="mobile-tab">
                            <span class="mobile-tab-text">
                                {{ $t(abas[abaSelecionada]) }}
                            </span>
                            <em class="mdi mdi-chevron-down"></em>
                        </div>

                        <b-dropdown-item
                            class="mobile-tab-list-item"
                            :class="{ active: abaSelecionada == i }"
                            aria-role="listitem"
                            v-for="(aba, i) in abas"
                            v-show="permissao.read"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            {{ $t(aba) }}
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

                <!-- Aba Informações -->
                <div v-if="!newToEdit && permissao.read" v-show="abaSelecionada == 0">
                    <div class="form-columns-fit page-container">
                        <div class="columns is-flex-wrap">
                            <div class="column is-5">
                                <v-input
                                    :id="'codigo'"
                                    ref="idtiposervicoerpInput"
                                    v-model="tiposervico.idtiposervicoerp"
                                    placeholder="placeholder-preencha"
                                    :maxlength="30"
                                    title="codigo"
                                    uppercase
                                />
                            </div>
                            <div class="column is-7">
                                <v-input
                                    v-model="tiposervico.descricao"
                                    :id="'nome'"
                                    :placeholder="'tipo-servico-contrato-placeholder'"
                                    :maxlength="30"
                                    :title="'descricao-tipo-servico'"
                                    :msg="'msg-campo-obrigatorio'"
                                    :invalid="!tiposervico.descricao"
                                    ref="titleInput"
                                    :required="true"
                                />
                            </div>
                            <div class="column is-4">
                                <label for="situacao" v-text="$t('situacao')" />
                                <v-select
                                    ref="situacaoSelect"
                                    :selectOnTab="true"
                                    :searchable="false"
                                    :options="situacoes"
                                    :value="situacao"
                                    @input="updateSituacao"
                                    :getOptionLabel="getLabel"
                                    placeholder="situacao-da-marca-placeholder"
                                    class="no-clear"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados')
                                    }}</template>
                                </v-select>
                            </div>
                            <div class="column is-4">
                                <label for="cor" v-text="$t('cor')" />
                                <ColorPicker
                                    id="cor"
                                    type="text"
                                    :color="color"
                                    ref="cpInput"
                                    @colorpicked="colorpicked"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="columns is-flex-wrap mt-2">
                        <div class="column is-6">
                            <div class="box">
                                <p v-text="$t('geral')" class="mb-2" />
                                <div class="columns is-flex-wrap">
                                    <div class="column is-6">
                                        <fSwitch
                                            :checked="tiposervico.ruptura"
                                            :text="$t('ruptura-troca')"
                                            :onChange="checkRuptura"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <fSwitch
                                            :checked="tiposervico.pesquisa"
                                            :text="$t('pesquisa')"
                                            :onChange="checkPesquisa"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <fSwitch
                                            :checked="tiposervico.share"
                                            :text="$t('share')"
                                            :onChange="checkShare"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <fSwitch
                                            :checked="tiposervico.vencimento"
                                            :text="$t('vencimento')"
                                            :onChange="checkVencimento"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <fSwitch
                                            :checked="tiposervico.formulario"
                                            :text="$t('formulario')"
                                            :onChange="checkFormulario"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <fSwitch
                                            :checked="tiposervico.reposicao"
                                            :text="$t('reposicao')"
                                            :onChange="checkReposicao"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('foto') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('foto') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.foto.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.foto.habilita"
                                                @click="changeCheckHabilita('foto')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.foto.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.foto.obriga"
                                                @click="changeCheckObriga('foto')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="box">
                                <p v-text="$t('assinatura')" class="mb-2" />
                                <div class="columns is-flex-wrap">
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('assinatura') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('assinatura') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.assinatura.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.assinatura.habilita"
                                                @click="changeCheckHabilita('assinatura')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.assinatura.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.assinatura.obriga"
                                                @click="changeCheckObriga('assinatura')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('nome') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('nome') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.assinaturaNome.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.assinaturaNome.habilita"
                                                @click="changeCheckHabilita('assinaturaNome')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.assinaturaNome.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.assinaturaNome.obriga"
                                                @click="changeCheckObriga('assinaturaNome')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('observacao') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('observacao') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.assinaturaObservacao.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.assinaturaObservacao.habilita"
                                                @click="changeCheckHabilita('assinaturaObservacao')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.assinaturaObservacao.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.assinaturaObservacao.obriga"
                                                @click="changeCheckObriga('assinaturaObservacao')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="box">
                                <p v-text="$t('parametrizacao-ruptura')" class="mb-2" />
                                <div class="columns is-flex-wrap">
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('tipo-campos') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('msg-ruptura-tipo-campo')"
                                            />
                                        </label>
                                        <vss-select
                                            ref="tipoCampoSelect"
                                            :searchable="false"
                                            :options="tipoCampoSelect"
                                            v-model="tipoCampoSelected"
                                            placeholder="selecione"
                                            :mlLabels="true"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('tipo-ruptura') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('msg-ruptura-tipo-ruptura')"
                                            />
                                        </label>
                                        <vss-select
                                            ref="tipoRupturaSelect"
                                            :searchable="false"
                                            :options="tipoRupturaSelect"
                                            v-model="tipoRupturaSelected"
                                            placeholder="selecione"
                                            :mlLabels="true"
                                        />
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('troca') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('troca') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.troca.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.troca.habilita"
                                                @click="changeCheckHabilita('troca')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.troca.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.troca.obriga"
                                                @click="changeCheckObriga('troca')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('area-venda') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('area-venda') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.area_venda.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.area_venda.habilita"
                                                @click="changeCheckHabilita('area_venda')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.area_venda.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.area_venda.obriga"
                                                @click="changeCheckObriga('area_venda')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('deposito') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('deposito') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.deposito.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.deposito.habilita"
                                                @click="changeCheckHabilita('deposito')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.deposito.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.deposito.obriga"
                                                @click="changeCheckObriga('deposito')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('houve-ruptura') }}
                                            <b-icon 
                                                icon="information" 
                                                size="is-small" 
                                                v-tippy 
                                                :title="$t('tipo-servico-habilita-obriga', { n: $t('houve-ruptura') })"
                                            />
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.houve_ruptura.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.houve_ruptura.habilita"
                                                @click="changeCheckHabilita('houve_ruptura')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.houve_ruptura.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.houve_ruptura.obriga"
                                                @click="changeCheckObriga('houve_ruptura')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label>
                                            {{ $t('quantidade-sugerida-web') }}
                                            <b-tooltip
                                                class="tooltip-label"
                                                :label="
                                                    $t('tipo-servico-habilita-obriga', { n: $t('quantidade-sugerida-web') })
                                                "
                                                position="is-right"
                                                type="is-dark"
                                                size="is-large"
                                                multilined
                                            >
                                                <b-icon icon="information" size="is-small" />
                                            </b-tooltip>
                                        </label>
                                        <div class="group-buttons">
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.qtde_sugerida.habilita ? 'is-primary' : ''"
                                                :outlined="!checks.qtde_sugerida.habilita"
                                                @click="changeCheckHabilita('qtde_sugerida')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                class="expanded-buttons"
                                                :type="checks.qtde_sugerida.obriga ? 'is-primary' : ''"
                                                :outlined="!checks.qtde_sugerida.obriga"
                                                @click="changeCheckObriga('qtde_sugerida')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Aba Formulários -->
                <div class="ma-2" v-if="permissao.read && isUpdate" v-show="abaSelecionada == 1">
                    <div class="tiposervico-table">
                        <b-table
                            :data="tiposervico.formFormularioGeralTabelas"
                            :per-page="20"
                            paginated
                            class="data-table"
                        >
                            <b-table-column
                                v-for="(f, i) in fieldsform"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete"
                                        type="is-danger"
                                        @click="confirmExclusion(props.row, props.index, 0)"
                                        icon-right="delete"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('excluir')"
                                    />
                                </div>
                                <!--
                                @69953 - props.row.index -> props.index
                                Utilizando a posicao da linha para alterar os valores
                                -->
                                <div v-else-if="f.key == 'obrigatorio'">
                                    <fSwitch
                                        :text="''"
                                        :checked="props.row[f.key]"
                                        :onChange="
                                            (e, val) => checkFormObriga(e, props.index)
                                        "
                                    />
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                    </div>
                    <button
                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        type="button"
                        class="btn add-campos"
                        @click="openModal(0)"
                    >
                        <p>
                            <svg class="svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/plus-box.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            {{ $t('adicionar-formulario') }}
                        </p>
                    </button>
                </div>

                <!-- Aba Eventos -->
                <div class="ma-2" v-if="permissao.read && isUpdate" v-show="abaSelecionada == 2">
                    <div class="eventos-table">
                        <b-table
                            :data="tiposervico.tiposervicotipoeventos"
                            :per-page="20"
                            paginated
                            class="data-table"
                        >
                            <b-table-column
                                v-for="(f, i) in fieldsevents"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete"
                                        type="is-danger"
                                        @click="confirmExclusion(props.row, props.index, 1)"
                                        icon-right="delete"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('excluir')"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                    </div>
                    <button
                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        type="button"
                        class="btn add-campos"
                        @click="openModal(1)"
                    >
                        <p>
                            <svg class="svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/plus-box.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            {{ $t('adicionar-eventos') }}
                        </p>
                    </button>
                </div>

                <!-- Aba Motivo de Foto -->
                <div class="ma-2" v-if="permissao.read && isUpdate" v-show="abaSelecionada == 3">
                    <div class="motivofotos-table">
                        <b-table
                            :data="tiposervico.tiposervicomotivofotos"
                            :per-page="20"
                            paginated
                            class="data-table"
                        >
                            <b-table-column
                                v-for="(f, i) in fieldsmotivofotos"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete"
                                        type="is-danger"
                                        @click="confirmExclusion(props.row, props.index, 2)"
                                        icon-right="delete"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('excluir')"
                                    />
                                </div>
                                <div v-else-if="f.key == 'obrigamotivo'">
                                    <!--
                                    @69953 - props.row.index -> props.index
                                    Utilizando a posicao da linha para alterar os valores 
                                    -->
                                    <fSwitch
                                        :text="''"
                                        :checked="props.row[f.key]"
                                        :onChange="
                                            (e, val) =>
                                                checkMotivoFotoObriga(e, props.index)
                                        "
                                    />
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                    </div>
                    <button
                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        type="button"
                        class="btn add-campos"
                        @click="openModal(2)"
                    >
                        <p>
                            <svg class="svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/plus-box.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            {{ $t('adicionar-motivo-foto') }}
                        </p>
                    </button>
                </div>
            </div>
        </div>

        <div class="modal" :class="modalIndex == 1 ? 'confirmation-window' : ''" v-if="modalOpen">
            <modal-container
                :list="listas[index]"
                :updateFunction="funclist[index]"
                :val="varlist[index]"
                :pageTitle="titlelist[index]"
                :containerName="contName[modalIndex]"
            />
        </div>
    </div>
</template>

<script>
import FilterBar from '@/components/shared/Filter.vue';
import fSwitch from '@/components/shared/form/Switch.vue';
import SelectBox from '@/components/shared/form/SelectBox.vue';
import ColorPicker from '@/components/shared/form/ColorPicker.vue';
import TipoServicoService from '@/services/promotor/TipoServicoService.js';
import EventoService from '@/services/promotor/EventoService.js';
import FormFormularioService from '@/services/FormFormularioService.js';
import MotivoFotoService from '@/services/promotor/MotivoFotoService.js';
import TipoServicoValidation from '@/services/validations/TipoServicoValidation.js';
import Message from '@/models/Message.js';

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == 'tipo-servico-new' && to.name == 'tipo-servico-edit') {
            this.newToEdit = true;
            next();
            setTimeout(() => {
                this.newToEdit = false;
                this.isUpdate = true;
                this.carregarDados();
            }, 500);
        } else {
            if (this.isChanged) {
                this.promptChangeTab(next);
                next(false);
            } else {
                next();
            }
        }
    },
    components: {
        FilterBar,
        fSwitch,
        SelectBox,
        ColorPicker,
    },
    data() {
        return {
            accessDenied: false,
            newToEdit: false,

            service: new TipoServicoService(this.$http, this.$router),
            formFormularioService: new FormFormularioService(this.$http, this.$router),
            eventservice: new EventoService(this.$http, this.$router),
            photoservice: new MotivoFotoService(this.$http, this.$router),
            validation: new TipoServicoValidation(this.msgs),

            isSaving: false,
            color: '#D0CFCF',
            tiposervico: {
                idtiposervico: null,
                idtiposervicoerp: null,
                descricao: '',
                situacao: 1,
                obrigafoto: false,
                obrigaassinatura: false,
                ocultanomeassinatura: false,
                obriganomeassinatura: false,
                ocultaobservacaoassinatura: false,
                obrigaobservacaoassinatura: false,
                ruptura: false,
                pesquisa: false,
                share: false,
                vencimento: false,
                formulario: false,
                foto: false,
                assinatura: false,
                formFormularioGeralTabelas: [],
                tiposervicotipoeventos: [],
                tiposervicomotivofotos: [],
                cor: this.color,
                reposicao: false,
                tipo_campo: false,
                tipo_ruptura: false,
                habilita_obriga_troca: null,
                habilita_obriga_area_venda: null,
                habilita_obriga_deposito: null,
                habilita_obriga_houve_ruptura: null,
                habilita_obriga_qtde_sugerida: null,
            },
            checks: {
                troca: { habilita: false, obriga: false },
                area_venda: { habilita: false, obriga: false },
                deposito: { habilita: false, obriga: false },
                houve_ruptura: { habilita: false, obriga: false },
                qtde_sugerida: { habilita: false, obriga: false },
                foto: { habilita: false, obriga: false },
                assinatura: { habilita: false, obriga: false },
                assinaturaNome: { habilita: false, obriga: false },
                assinaturaObservacao: { habilita: false, obriga: false },
            },
            fieldsform: [
                { key: 'titulo', width: null, sortable: true, sortFn: null },
                { key: 'obrigatorio', width: null, sortable: false, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            fieldsevents: [
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            fieldsmotivofotos: [
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'obrigamotivo', width: null, sortable: false, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],

            abas: ['dados-cadastrais', 'formularios', 'eventos', 'motivo-de-foto'],
            abaSelecionada: 0,
            abasAbertas: {},
            debounceTab: null,

            currentPageform: 1,
            currentPageEvent: 1,
            currentPageMotivoFotos: 1,
            perPageform: 10,
            perPageEvent: 10,
            perPageMotivoFotos: 10,
            listas: [[], [], [], []],
            listasfull: [],
            funclist: [],
            varlist: [],
            titlelist: ['adicionar-formulario', 'adicionar-eventos', 'adicionar-motivo-foto'],
            index: 0,
            modalOpen: false,
            title: '',
            msgs: [],
            allowDelete: false,
            deleteThis: {},
            modalIndex: 0,
            contName: ['ModalVSelect'],
            delcontrol: 0,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            tipoCampoSelect: [
                { label: 'campo-numero', id: 0 },
                { label: 'multipla-escolha', id: 1 },
            ],
            tipoCampoSelected: { label: 'campo-numero', id: 0 },
            tipoRupturaSelect: [
                { label: 'check', id: 0 },
                { label: 'multipla-escolha', id: 1 },
            ],
            tipoRupturaSelected: { label: 'check', id: 0 },
            isUpdate: false,
            permissao: {},
            isLoading: false,
        };
    },
    mounted() {
        if (
            this.$route.query.abaSelecionada &&
            this.abas.includes(this.$route.query.abaSelecionada)
        ) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'tipos-servicos');

        const havePermissionCreate = !this.isUpdate && !this.permissao.create;
        const havePermissionToRead = this.isUpdate && !this.permissao.read;

        if (havePermissionCreate || havePermissionToRead) {
            this.accessDenied = true;
            return;
        }

        if (this.isUpdate) {
            this.carregarDados();
        } else {
            this.loadTables();
            this.loadModalLists();
        }

        this.abasAbertas['dados-cadastrais'] = true;
    },

    methods: {
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;

            clearTimeout(this.debounceTab);
            this.debounceTab = setTimeout(() => {
                // recria objeto de query da url com novo valor para tipo negócio
                let query = {};
                if (this.$route.query) {
                    query = Object.assign({}, this.$route.query);
                    if (query.abaSelecionada) delete query.abaSelecionada;
                }

                query.abaSelecionada = this.abas[this.abaSelecionada];
                // muda a url
                this.$router.push({ query: query });
            }, 400);
        },
        colorpicked(color) {
            this.color = color;
            this.tiposervico.cor = color;
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.tiposervico.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.tiposervico.situacao);
        },
        getTipoCampo() {
            return this.tipoCampoSelect.filter((tc) => tc.id === this.tiposervico.tipo_campo)[0];
        },
        getTipoRuptura() {
            return this.tipoRupturaSelect.filter((tp) => tp.id === this.tiposervico.tipo_ruptura)[0];
        },
        carregarDados() {
            this.isLoading = true;
            this.service.find(this.$route.params.id).then((body) => {
                let ts = body.content;

                this.tiposervico.idtiposervico = ts.idtiposervico;
                this.tiposervico.idtiposervicoerp = ts.idtiposervicoerp;
                this.tiposervico.descricao = ts.descricao;
                this.tiposervico.cor = ts.cor;
                this.tiposervico.obrigafoto = ts.obrigafoto == 1;
                this.tiposervico.obrigaassinatura = ts.obrigaassinatura == 1;
                this.tiposervico.ocultanomeassinatura = ts.ocultanomeassinatura == 1;
                this.tiposervico.obriganomeassinatura = ts.obriganomeassinatura == 1;
                this.tiposervico.ocultaobservacaoassinatura = ts.ocultaobservacaoassinatura == 1;
                this.tiposervico.obrigaobservacaoassinatura = ts.obrigaobservacaoassinatura == 1;
                this.tiposervico.ruptura = ts.ruptura == 1;
                this.tiposervico.pesquisa = ts.pesquisa == 1;
                this.tiposervico.share = ts.share == 1;
                this.tiposervico.vencimento = ts.vencimento == 1;
                this.tiposervico.situacao = ts.situacao;
                this.tiposervico.minimofoto = ts.minimofoto;
                this.tiposervico.formFormularioGeralTabelas = ts.formFormularioGeralTabelas;
                this.tiposervico.tiposervicotipoeventos = ts.tiposervicotipoeventos;
                this.tiposervico.tiposervicomotivofotos = ts.tiposervicomotivofotos;
                this.tiposervico.formulario = ts.formulario;
                this.tiposervico.foto = ts.foto;
                this.tiposervico.assinatura = ts.assinatura;
                this.tiposervico.reposicao = ts.reposicao;
                this.tiposervico.tipo_campo = ts.tipo_campo;
                this.tiposervico.tipo_ruptura = ts.tipo_ruptura;
                this.tiposervico.habilita_obriga_troca = ts.habilita_obriga_troca;
                this.tiposervico.habilita_obriga_area_venda = ts.habilita_obriga_area_venda;
                this.tiposervico.habilita_obriga_deposito = ts.habilita_obriga_deposito;
                this.tiposervico.habilita_obriga_houve_ruptura = ts.habilita_obriga_houve_ruptura;
                this.tiposervico.habilita_obriga_qtde_sugerida = ts.habilita_obriga_qtde_sugerida;

                this.situacao = this.getSituacao();
                this.tipoCampoSelected = this.getTipoCampo();
                this.tipoRupturaSelected = this.getTipoRuptura();

                this.mapHabilita();
                this.mapObriga();

                this.tiposervico.formFormularioGeralTabelas.map((f, i) => {
                    f.titulo = f.formFormulario.titulo;
                    f.excluir = 'excluir';
                    return f;
                });
                this.tiposervico.tiposervicotipoeventos.map((e) => {
                    e.descricao = e.tipoevento.descricao;
                    e.excluir = 'excluir';
                    return e;
                });
                this.tiposervico.tiposervicomotivofotos.map((mf, i) => {
                    mf.descricao = mf.motivofoto.descricao;
                    mf.obrigamotivo = mf.obrigamotivo == 1;
                    mf.excluir = 'excluir';
                    mf.index = i;
                    return mf;
                });

                this.title = this.tiposervico.descricao;
                
                this.color = this.tiposervico.cor;
            })
            .catch((e) => {
                this.tiposervico.idtiposervico = null;
                this.$root.msgs.push(new Message('error', 'msg-erro-load'));
            })
            .finally((_) => {
                this.isLoading = false;
                if (this.tiposervico.idtiposervico != null) {
                    this.loadTables();
                    this.loadModalLists();
                }
            });
        },
        mapHabilita() {
            this.checks.troca.habilita = this.mapChecksHabilita(
                this.tiposervico.habilita_obriga_troca
            );
            this.checks.area_venda.habilita = this.mapChecksHabilita(
                this.tiposervico.habilita_obriga_area_venda
            );
            this.checks.deposito.habilita = this.mapChecksHabilita(
                this.tiposervico.habilita_obriga_deposito
            );
            this.checks.houve_ruptura.habilita = this.mapChecksHabilita(
                this.tiposervico.habilita_obriga_houve_ruptura
            );
            this.checks.qtde_sugerida.habilita = this.mapChecksHabilita(
                this.tiposervico.habilita_obriga_qtde_sugerida
            );
            this.checks.foto.habilita = this.tiposervico.foto;
            this.checks.assinatura.habilita = this.tiposervico.assinatura;
            this.checks.assinaturaNome.habilita = !this.tiposervico.ocultanomeassinatura;
            this.checks.assinaturaObservacao.habilita = !this.tiposervico.ocultaobservacaoassinatura;
        },
        mapChecksHabilita(check) {
            return check == 1 || check == 2;
        },
        mapObriga() {
            this.checks.troca.obriga = this.mapChecksObriga(
                this.tiposervico.habilita_obriga_troca
            );
            this.checks.area_venda.obriga = this.mapChecksObriga(
                this.tiposervico.habilita_obriga_area_venda
            );
            this.checks.deposito.obriga = this.mapChecksObriga(
                this.tiposervico.habilita_obriga_deposito
            );
            this.checks.houve_ruptura.obriga = this.mapChecksObriga(
                this.tiposervico.habilita_obriga_houve_ruptura
            );
            this.checks.qtde_sugerida.obriga = this.mapChecksObriga(
                this.tiposervico.habilita_obriga_qtde_sugerida
            );
            this.checks.foto.obriga = this.tiposervico.obrigafoto;
            this.checks.assinatura.obriga = this.tiposervico.obrigaassinatura;
            this.checks.assinaturaNome.obriga = this.tiposervico.obriganomeassinatura;
            this.checks.assinaturaObservacao.obriga = this.tiposervico.obrigaobservacaoassinatura;
        },
        mapChecksObriga(check) {
            return check == 2;
        },
        loadTables() {
            this.loadForm();
            this.loadEvent();
            this.loadPhoto();
        },
        loadForm(param) {
            this.isLoading = true;
            this.formFormularioService
                .findAllCombo(1, 100, 'pro', param ? param : '')
                .then(this.mapItemsForm)
                .then((value) => {
                    this.listasfull[0] = value;

                    if (this.listasfull[0]) {
                        this.listas[0] = this.listasfull[0].filter(this.containsForm);
                    }
                })
                .catch((e) => {
                    this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        loadEvent(param) {
            this.isLoading = true;
            this.eventservice
                .findAllCombo(param ? param : '')
                .then(this.mapItemsEvents)
                .then((value) => {
                    this.listasfull[1] = value;

                    if (this.listasfull[1]) {
                        this.listas[1] = this.listasfull[1].filter(this.containsEvents);
                    }
                })
                .catch((e) => {
                    this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        loadPhoto(param) {
            this.isLoading = true;
            this.photoservice
                .findAllCombo(param ? param : '')
                .then(this.mapItemsPhotos)
                .then((value) => {
                    this.listasfull[2] = value;

                    if (this.listasfull[2]) {
                        this.listas[2] = this.listasfull[2].filter(this.containsMotivoFoto);
                    }
                })
                .catch((e) => {
                    this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        loadModalLists() {
            this.funclist.splice(0, 0, this.updateForm);
            this.funclist.splice(1, 0, this.updateEvent);
            this.funclist.splice(2, 0, this.updateMotivofoto);

            this.varlist.splice(0, 0, {});
            this.varlist.splice(1, 0, {});
            this.varlist.splice(2, 0, {});
        },
        containsForm(value, index, list) {
            let copy = false;
            if (!value) {
                return !copy;
            }

            if (this.tiposervico.formFormularioGeralTabelas.length > 0) {
                this.tiposervico.formFormularioGeralTabelas.forEach((form) => {
                    if (value.form && form.formFormulario.id == value.form.id) {
                        copy = true;
                    }
                });
            }
            return !copy;
        },
        containsEvents(value, index, list) {
            let copy = false;
            if (!value) {
                return !copy;
            }

            if (this.tiposervico.tiposervicotipoeventos.length > 0) {
                this.tiposervico.tiposervicotipoeventos.forEach((ev) => {
                    /*
                        @69953 - value.id -> value.evento
                        value.id.tipoevento -> value.evento.idtipoevento
                        Validar se contem um evento na lista.
                    */
                    if (value.evento && ev.tipoevento.idtipoevento == value.evento.idtipoevento) {
                        copy = true;
                    }
                });
            }

            return !copy;
        },
        containsMotivoFoto(value, index, list) {
            let copy = false;
            if (!value) {
                return !copy;
            }

            if (this.tiposervico.tiposervicomotivofotos.length > 0) {
                /*
                @69953 - value.id -> value.photo
                value.id.idmotivofoto -> value.photo.idmotivofoto
                Validar se contem um motivofoto na lista.
                */
                this.tiposervico.tiposervicomotivofotos.forEach((mf) => {
                    if (value.photo && mf.motivofoto.idmotivofoto == value.photo.idmotivofoto) {
                        copy = true;
                    }
                });
            }
            return !copy;
        },
        mapItemsForm(body) {
            /*
                @69953 - Alteracao no id para resolver o erro de
                chave duplicada nos formularios e adicionado a chave
                form.
            */
            const formlist = body.content.map((f) => {
                return {
                    id: f.id,
                    uuid: f.uuid,
                    form: this.mapForm(f),
                    label: f.titulo,
                };
            });
            return formlist;
        },
        mapForm(form) {
            return {
                id: form.id,
                uuid: form.uuid,
                idformulario: form.id,
                titulo: form.titulo,
            };
        },
        mapItemsEvents(body) {
            /*
                @69953 - Alteracao no id para resolver o erro de
                chave duplicada nos eventos e adicionado a chave
                evento.
            */
            let eventslist = body.content.map((e) => {
                return {
                    id: e.id,
                    evento: e,
                    label: e.descricao,
                };
            });
            return eventslist;
        },
        mapItemsPhotos(body) {
            /*
                @69953 - Alteracao no id para resolver o erro de
                chave duplicada nos motivosfotos, e adicionado
                a chave photo.
            */
            let motivofotolist = body.content.map((mf) => {
                return {
                    id: mf.id,
                    photo: mf,
                    label: mf.descricao,
                };
            });
            return motivofotolist;
        },
        checkRuptura(e) {
            this.tiposervico.ruptura = e.target.checked;
        },
        checkPesquisa(e) {
            this.tiposervico.pesquisa = e.target.checked;
        },
        checkShare(e) {
            this.tiposervico.share = e.target.checked;
        },
        checkVencimento(e) {
            this.tiposervico.vencimento = e.target.checked;
        },
        checkFormulario(e) {
            this.tiposervico.formulario = e.target.checked;
        },
        checkFoto(e) {
            this.tiposervico.foto = e.target.checked;
        },
        checkAssinatura(e) {
            this.tiposervico.assinatura = e.target.checked;
        },
        checkReposicao(e) {
            this.tiposervico.reposicao = e.target.checked;
        },
        checkFormObriga(e, index) {
            this.tiposervico.formFormularioGeralTabelas[index].obrigatorio = e.target.checked;
        },
        checkMotivoFotoObriga(e, index) {
            this.tiposervico.tiposervicomotivofotos[index].obrigamotivo = e.target.checked;
        },
        controlObservacaoAssinatura(oculta) {
            if (this.tiposervico.ocultaobservacaoassinatura) {
                if (!oculta) {
                    this.tiposervico.ocultaobservacaoassinatura = !this.tiposervico
                        .obrigaobservacaoassinatura;
                } else {
                    this.tiposervico.obrigaobservacaoassinatura = !this.tiposervico
                    .ocultaobservacaoassinatura;
                }
            }
        },
        updateForm(f) {
            if (f && f.id != null) {
                let assform = {
                    /*
                        @69953 - f.id -> f.form
                        Foi alterado para passar o objeto form.
                    */
                    formFormulario: f.form,
                    titulo: f.label,
                    obrigatorio: false,
                    excluir: 'excluir',
                    ativo: true,
                    _cellVariants: { excluir: 'col-medium' },
                };
                this.tiposervico.formFormularioGeralTabelas.splice(
                    this.tiposervico.formFormularioGeralTabelas.length,
                    0,
                    assform
                );
                this.varlist.splice(0, 1, f);
                this.listas[0] = this.listasfull[0].filter(this.containsForm);
                this.modalOpen = false;
            }
        },
        updateEvent(e) {
            if (e && e.id != null) {
                let assevent = {
                    /*
                        @69953 - e.id -> e.evento
                        Foi alterado para passar o objeto evento.
                    */
                    tipoevento: e.evento,
                    excluir: 'excluir',
                    idtiposervico: this.tiposervico.idtiposervico,
                    _cellVariants: { excluir: 'col-medium' },
                    descricao: e.label,
                };
                this.tiposervico.tiposervicotipoeventos.splice(
                    this.tiposervico.tiposervicotipoeventos.length,
                    0,
                    assevent
                );
                this.varlist.splice(1, 1, e);
                this.listas[1] = this.listasfull[1].filter(this.containsEvents);
                this.modalOpen = false;
            }
        },
        updateMotivofoto(mf) {
            if (mf && mf.id != null) {
                let assmotivofoto = {
                    /*
                        @69953 - mf.id -> mf.photo
                        Foi alterado passar o objeto motivofoto.
                    */
                    motivofoto: mf.photo,
                    descricao: mf.label,
                    obrigaeventoantesformulario: false,
                    excluir: 'excluir',
                    obrigamotivo: false,
                    idtiposervico: this.tiposervico.idtiposervico,
                    _cellVariants: { excluir: 'col-medium' },
                };
                this.tiposervico.tiposervicomotivofotos.splice(
                    this.tiposervico.tiposervicomotivofotos.length,
                    0,
                    assmotivofoto
                );
                this.varlist.splice(2, 1, mf);
                this.listas[2] = this.listasfull[2].filter(this.containsMotivoFoto);
                this.modalOpen = false;
            }
        },
        confirmExclusion(item, index, fep) {
            this.delcontrol = fep;
            this.deleteThis = index;

            let label = item.titulo;

            if (fep == 1 || fep == 2) {
                label = item.descricao;
            }

            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n: label }),
                onConfirm: this.handleExclusion,
            });
        },
        handleExclusion() {
            switch (this.delcontrol) {
                case 0:
                    this.excluirForm(this.deleteThis);
                    break;
                case 1:
                    this.excluirEvent(this.deleteThis);
                    break;
                case 2:
                    this.excluirMotivoFoto(this.deleteThis);
                    break;
            }
        },
        excluirForm(itemindex) {
            this.isLoading = true;
            let item = this.tiposervico.formFormularioGeralTabelas[itemindex];
            if (item.id) {
                this.service.deleteForm(item.id)
                    .then(() => {
                        this.tiposervico.formFormularioGeralTabelas.splice(itemindex, 1);
                    })
                    .catch((e) => {
                        this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                    })
                    .finally((_) => {
                        this.isLoading = false;
                    });
            } else {
                this.tiposervico.formFormularioGeralTabelas.splice(itemindex, 1);
            }

            /*
            @69953 - Alteracao no id para resolver o erro de
            chave duplicada nos formularios e adicionado a chave
            form.
            */
            let roolBackItemForList = {
                id: item.formFormulario.id,
                form: item.formFormulario,
                label: item.titulo,
            };

            this.listas[0].push(roolBackItemForList);

            this.allowDelete = false;
            this.deleteThis = {};
            this.delcontrol = 0;
            this.modalIndex = 0;
        },
        excluirEvent(itemindex) {
            this.isLoading = true;
            let item = this.tiposervico.tiposervicotipoeventos[itemindex];
            if (item.idasstiposervicotipoevento) {
                this.service.deleteEvent(item.idasstiposervicotipoevento)
                    .then(() => {
                    this.tiposervico.tiposervicotipoeventos.splice(itemindex, 1);
                    })
                    .catch((e) => {
                        this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                    })
                    .finally((_) => {
                        this.isLoading = false;
                    });
            } else {
                this.tiposervico.tiposervicotipoeventos.splice(itemindex, 1);
            }
            /*
            @69953 - Alteracao no id para resolver o erro de
            chave duplicada nos eventos e adicionado a cahve envento.
            */
            let roolBackItemForList = {
                id: item.tipoevento.id,
                evento: item.tipoevento,
                label: item.descricao,
            };
            this.listas[1].push(roolBackItemForList);

            this.allowDelete = false;
            this.deleteThis = {};
            this.delcontrol = 0;
            this.modalIndex = 0;
        },
        excluirMotivoFoto(itemindex) {
            this.isLoading = true;
            let item = this.tiposervico.tiposervicomotivofotos[itemindex];
            if (item.idasstiposervicomotivofoto) {
                this.service.deleteReasonPhoto(item.idasstiposervicomotivofoto)
                    .then(() => {
                        this.tiposervico.tiposervicomotivofotos.splice(itemindex, 1);
                    })
                    .catch((e) => {
                        this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                    })
                    .finally((_) => {
                        this.isLoading = false;
                    });
            } else {
                this.tiposervico.tiposervicomotivofotos.splice(itemindex, 1);
            }

            /*
            @69953 - Alteracao no id para resolver o erro de
            chave duplicada nos motivosfotos e adicionado a
            chave photo.
            */
            let roolBackItemForList = {
                id: item.motivofoto.id,
                photo: item.motivofoto,
                label: item.descricao,
            };
            this.listas[2].push(roolBackItemForList);

            this.allowDelete = false;
            this.deleteThis = {};
            this.delcontrol = 0;
            this.modalIndex = 0;
        },
        saveTipoServico() {
            this.tiposervico = this.mapTosave(this.tiposervico, 'cor');
            if (this.validation.validate(this.tiposervico, this.$refs)) {
                this.isSaving = true;
                this.mapSaveChecks();
                this.boolToInt();

                this.service
                    .save(this.tiposervico)
                    .then((body) => {
                        let msg = 'msg-tiposervico-salva';
                        if (this.isUpdate) {
                            msg = 'msg-tiposervico-editado';
                        }
                        this.$root.msgs.push(new Message('success', msg, true));
                        if (!this.isUpdate) {
                            this.redirectToEdit(body.content.id);
                        } else {
                            this.carregarDados();
                        }
                    })
                    .catch((e) => {
                        this.$root.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        mapSaveChecks() {
            this.tiposervico.habilita_obriga_troca = this.setChecksToSave(
                this.checks.troca
            );
            this.tiposervico.habilita_obriga_area_venda = this.setChecksToSave(
                this.checks.area_venda
            );
            this.tiposervico.habilita_obriga_deposito = this.setChecksToSave(
                this.checks.deposito
            );
            this.tiposervico.habilita_obriga_houve_ruptura = this.setChecksToSave(
                this.checks.houve_ruptura
            );
            this.tiposervico.habilita_obriga_qtde_sugerida = this.setChecksToSave(
                this.checks.qtde_sugerida
            );

            this.tiposervico.foto = this.checks.foto.habilita
            this.tiposervico.obrigafoto = this.checks.foto.obriga;

            this.tiposervico.assinatura = this.checks.assinatura.habilita;
            this.tiposervico.obrigaassinatura = this.checks.assinatura.obriga;

            this.tiposervico.ocultanomeassinatura = !this.checks.assinaturaNome.habilita;
            this.tiposervico.obriganomeassinatura = this.checks.assinaturaNome.obriga;

            this.tiposervico.ocultaobservacaoassinatura = !this.checks.assinaturaObservacao.habilita;
            this.tiposervico.obrigaobservacaoassinatura = this.checks.assinaturaObservacao.obriga;
        },
        setChecksToSave(obj) {
            if (obj.obriga) {
                return 2;
            } else if (obj.habilita) {
                return 1;
            } else {
                return 0;
            }
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'tipo-servico-edit',
                    params: { id: id },
                });
            }, 500);
        },
        boolToInt() {
            const boolFields = [
                'obrigafoto', 'obrigaassinatura', 'ocultanomeassinatura',
                'obriganomeassinatura', 'ocultaobservacaoassinatura',
                'obrigaobservacaoassinatura', 'ruptura', 'pesquisa', 'share',
                'vencimento', 'formulario', 'foto', 'assinatura', 'reposicao',
                'tipo_campo', 'tipo_ruptura'
            ];

            boolFields.forEach(field => {
                this.tiposervico[field] = this.tiposervico[field] ? 1 : 0;
            });

            if (this.tiposervico.formFormularioGeralTabelas) {
                this.tiposervico.formFormularioGeralTabelas.forEach(tsf => {
                    tsf.obrigatorio = tsf.obrigatorio ? 1 : 0;
                });
            }

            if (this.tiposervico.tiposervicomotivofotos) {
                this.tiposervico.tiposervicomotivofotos.forEach(tsmf => {
                    tsmf.obrigamotivo = tsmf.obrigamotivo ? 1 : 0;
                });
            }

            this.tiposervico.tipo_campo = this.tipoCampoSelected.id;
            this.tiposervico.tipo_ruptura = this.tipoRupturaSelected.id;
        },
        openModal(i) {
            this.delcontrol = 0;
            this.index = i;
            this.modalOpen = true;
        },
        changeCheckHabilita(v) {
            this.checks[v].habilita = !this.checks[v].habilita;
            if (!this.checks[v].habilita) this.checks[v].obriga = false;
        },
        changeCheckObriga(v) {
            this.checks[v].obriga = !this.checks[v].obriga;
            if (this.checks[v].obriga) this.checks[v].habilita = true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';

#main {
    padding: 0 20px;
    height: 100%;
    display: flex;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .box {
            min-height: 100%;
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

.add-campos {
    @include exclude-button();
    box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
    position: relative;
    border-radius: 10px;
    padding: 10px 80px;
    text-align: center;
    border-radius: 6px;
    left: 50%;
    transform: translate(-50%);
    margin-top: 60px;
    margin-bottom: 40px;

    > p {
        display: flex;
        align-items: center;
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: $darker-gray-color;

        > svg {
            margin-right: 10px;
            fill: $darker-gray-color;
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
